import React from "react"
import { Link } from "gatsby-link"
import IconArrow from "../../images/icons/icon-arrow.svg"
import domParser from "../../utils/parser"

type Props = {
  html: string
  author: {
    profile_image: string
    name: string
    slug: string
    bio: string
  }
}

type UsefulLink =
  | null
  | {
      url: string
      title: string
    }[]

const ArticleFooterBottom = (props: Props) => {
  const { author, html } = props
  let usefulLinks: UsefulLink = null
  const parsedHtml = domParser(html)
  try {
    const usefulLinksEle = parsedHtml.getElementById("usefulLinks")
    if (usefulLinksEle) {
      usefulLinks = JSON.parse(usefulLinksEle.innerHTML)
    }
  } catch (error) {
    console.log(error)
  }

  return (
    <div className="section--lg bg-neutral-50">
      <div className="container--boxed">
        <div className="max-w-4xl mx-auto">
          <div className="flex-col sm:flex-row flex gap-14 sm:gap-20">
            {usefulLinks && (
              <div className="md:max-w-xs w-full">
                <p className="text--xl font-semibold">Useful links</p>
                <ul className="space-y-3 sm:space-y-4 mt-6">
                  {usefulLinks.map((link, i) => (
                    <li key={i}>
                      <a
                        className="inline-flex gap-2 text-base text-neutral-700 font-semibold"
                        href={link.url}
                      >
                        <img src={IconArrow} alt="" width={12} height={12} />
                        <span>{link.title}</span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            <div>
              <p className="text--xl font-semibold">About the Author</p>
              <div>
                <div className="flex items-center my-4">
                  <div className="flex size-12 rounded-3xl overflow-hidden">
                    <img
                      src={author.profile_image}
                      width={48}
                      height={48}
                      className="object-cover"
                      alt={author.name}
                    />
                  </div>
                  <div className="pl-3">
                    <p className="text-neutral-700 text--md font-semibold">
                      <Link
                        to={`/author/${author.slug}`}
                        className="hover:underline"
                      >
                        {author.name}
                      </Link>
                    </p>
                  </div>
                </div>
                <p
                  className="text--md text-neutral-500"
                  style={{ maxWidth: 704 }}
                >
                  {author.bio}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ArticleFooterBottom
